import { useBadgeHistoryTable } from '../../../../../ui/features/badge-management/hooks/useBadgeHistoryTable';
import { useBadgeHistoryTableColumns } from '../../../../../ui/features/badge-management/hooks/useBadgeHistoryTableColumns';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import React from 'react';
export const BadgeHistoryTable = ({ badgeId }) => {
    const { dataTableProps, filtersBarProps } = useBadgeHistoryTable({ badgeId });
    const columns = useBadgeHistoryTableColumns();
    const { t } = useBadgingTranslation();
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'search',
            label: t('badges.badgeDetails.badgeHistoryTable.filters.search'),
            sx: { maxWidth: { xs: undefined, sm: 340 } },
        });
        builder.quickDateRangeFilter({
            dataPath: 'date',
            label: t('badges.badgeDetails.badgeHistoryTable.filters.date'),
            sx: { maxWidth: { xs: undefined, sm: 340 } },
        });
        builder.quickFilterMultiSelect({
            dataPath: 'action',
            widget: 'form.multiSelect',
            valueProvider: 'badgeHistoryActions',
            label: t('badges.badgeDetails.badgeHistoryTable.filters.action'),
            sx: { maxWidth: { xs: undefined, sm: 280 } },
        });
    }, [t]);
    return React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })) }));
};
